import { render, staticRenderFns } from "./icon-count.vue?vue&type=template&id=79860d9b&scoped=true"
import script from "./icon-count.vue?vue&type=script&lang=js"
export * from "./icon-count.vue?vue&type=script&lang=js"
import style0 from "./icon-count.vue?vue&type=style&index=0&id=79860d9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79860d9b",
  null
  
)

export default component.exports